import { LoginByTokenResponseDto } from '@modusign/openapi-client-user/model';

import { requestApi } from '@app/api';

export default function fetchAccessTokenByParticipantLoginLink({
  loginLink,
}: {
  loginLink: string;
}): Promise<LoginByTokenResponseDto> {
  return requestApi<LoginByTokenResponseDto>({
    url: loginLink,
    method: 'GET',
    credentials: false,
  }).then((response) => response.data);
}
